import * as CONST from '../common/const';
import api from 'utils/api';
import { logger } from '@amzn/awsui-components-react/polaris/internal/core/runtime/src';

export const fetchJobsDataRequest = () => {
    return {
        type: CONST.FETCH_JOBS_REQUEST
    }
}

export const fetchJobsDataSuccess = (jobsData) => {
    const newJobsData = [];
    for (let jobData of jobsData.ICJobs) {
        let newJobData = {...jobData};
        newJobData.calculationDetails = JSON.parse(newJobData.calculationDetails);
        newJobsData.push(newJobData);
    }
    return {
        type: CONST.FETCH_JOBS_SUCCESS,
        jobsData: newJobsData
    }
}

export const saveJobsDataSuccess = (id, newCalcData) => {
    return {
        type: CONST.SAVE_JOBS_SUCCESS,
        id: id,
        newCalcData: newCalcData
    }
}

export const fetchJobsDataFailure = (error) => {
    return {
        type: CONST.FETCH_JOBS_FAILURE,
        error: error,
    };
};


export const fetchJobsData = () => async (dispatch, getState) => {

    dispatch(fetchJobsDataRequest());
    try {
        const result = await api.getCalcDetailData();
        dispatch(fetchJobsDataSuccess(result));
    } catch (e) {
        dispatch(fetchJobsDataFailure(e));
    }
};